export const CREDITCARD_PAYMENT_STATUS = {
  ok: 1,
  wait: 0,
  error: -1
}
